import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tableCss } from './css/table';

@customElement('mw-freqs')
export class MyElement extends LitElement {
  @property()
  freqs: { [key: string]: number; } = {};

  static get styles() {
    return [tableCss];
  }

  render() {
    const freqsArray = Object
      .entries(this.freqs)
      .map(([letter, freq]) => ({ letter, freq }));

    // Sort descending by frequency
    freqsArray.sort((a, b) => b.freq - a.freq);

    return html`
      <table>
        <thead>
          <tr>
            <td>Letter</td>
            <td>Words</td>
          </tr>
        </thead>
        <tbody>
          ${freqsArray.map(freq => html`
          <tr>
            <td>${freq.letter.toUpperCase()}</td>
            <td class="numerical">${freq.freq}</td>
          </tr>
          `)}
        </tbody>
      </table>
    `;
  }
}
